import { useEffect, useMemo } from 'react';

import _ from 'lodash';

import { isSSR } from '../helpers';
import { sessionPing } from './api';
import { USER_BROWSER_INTERACTION_THROTTLE_TIME } from './constants';
import { useUserDataQueryBase } from './useUserData';
import { getIsUserAuthorized } from './utils';

export const useAutoProlongSession = (throttleTime: number = USER_BROWSER_INTERACTION_THROTTLE_TIME) => {
    const { userData } = useUserDataQueryBase({ isEnabled: !isSSR() });
    const isRememberMe: boolean | undefined = userData?.rememberMe;

    const callProlongAuthSession = useMemo(() => {
        return _.throttle(() => sessionPing(), throttleTime, { leading: true, trailing: false });
    }, [throttleTime]);

    useEffect(() => {
        const isPingEnabled = getIsUserAuthorized() && isRememberMe === false;

        if (isPingEnabled) {
            window.addEventListener('mouseup', callProlongAuthSession);
            window.addEventListener('keyup', callProlongAuthSession);
        }

        return () => {
            window.removeEventListener('mouseup', callProlongAuthSession);
            window.removeEventListener('keyup', callProlongAuthSession);
        };
    }, [callProlongAuthSession, isRememberMe]);
};
